import React, { createContext, useState, useContext, useEffect } from 'react';
import { readStoredLanguage, useLanguage } from './LanguageContext';

const AvatarContext = createContext();

// Default advisor name shown until the user saves one; the English UI uses a romanized name.
export const getDefaultAdvisorName = (language) => (language === 'en' ? 'Alex Wang' : '王曉明');

export const AvatarProvider = ({ children }) => {
  const language = useLanguage()?.language ?? readStoredLanguage();
  const [avatarSettings, setAvatarSettings] = useState({
    style: localStorage.getItem('avatarStyle') || 'avataaars',
    bgColor: localStorage.getItem('avatarBgColor') || 'b6e3f4',
    seed: localStorage.getItem('avatarSeed') || '1234',
    name: localStorage.getItem('advisorName') || getDefaultAdvisorName(language),
  });

  // Follow the interface language while no name has been saved; a saved name is never replaced.
  useEffect(() => {
    if (localStorage.getItem('advisorName')) return;
    const defaultName = getDefaultAdvisorName(language);
    setAvatarSettings((prev) => (prev.name === defaultName ? prev : { ...prev, name: defaultName }));
  }, [language]);

  const updateAvatarSettings = (newSettings) => {
    setAvatarSettings(newSettings);
  };

  return (
    <AvatarContext.Provider value={{ avatarSettings, updateAvatarSettings }}>
      {children}
    </AvatarContext.Provider>
  );
};

export const useAvatar = () => useContext(AvatarContext);
